export default __webpack_public_path__ + "static/media/Laurent_Rioux.52dcb26a.jpg";